'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogDetailsIfNeeded = exports.isCatalogDetailLoading = exports.getLoadTimeForCatalogDetail = exports.getCatalogDetail = exports.LOAD_CATALOG_DETAILS_SUCCESS = exports.LOAD_CATALOG_DETAILS_REQUEST = exports.LOAD_CATALOG_DETAILS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('./config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOG_DETAILS_FAIL = exports.LOAD_CATALOG_DETAILS_FAIL = 'la/domain/catalogDetail/LOAD_FAIL';
var LOAD_CATALOG_DETAILS_REQUEST = exports.LOAD_CATALOG_DETAILS_REQUEST = 'la/domain/catalogDetail/LOAD_REQUEST';
var LOAD_CATALOG_DETAILS_SUCCESS = exports.LOAD_CATALOG_DETAILS_SUCCESS = 'la/domain/catalogDetail/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

var splitCustomTerms = function splitCustomTerms(terms) {
    var paymentDetails = terms.find(function (term) {
        return term.id === 'pay';
    }) || {};
    var shippingDetails = terms.find(function (term) {
        return term.id === 'ship';
    }) || {};
    var customTerms = terms.filter(function (term) {
        return term.id !== 'pay' && term.id !== 'ship';
    });

    return {
        customTerms: customTerms,
        paymentDetails: paymentDetails.data || '',
        shippingDetails: shippingDetails.data || ''
    };
};

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_CATALOG_DETAILS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.catalogIds)
            });
        case LOAD_CATALOG_DETAILS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_CATALOG_DETAILS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.catalogDetails) {
                action.payload.catalogDetails.forEach(function (item) {
                    existing[item.catalogId] = (0, _extends3.default)({
                        catalogId: item.catalogId
                    }, splitCustomTerms(item.customTerms), {
                        streamId: item.streamId || 0,
                        terms: item.terms,
                        videoSource: item.videoSource || ''
                    });
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogDetail;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCatalogDetail = exports.getCatalogDetail = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForCatalogDetail = exports.getLoadTimeForCatalogDetail = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCatalogDetailLoading = exports.isCatalogDetailLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchCatalogDetail = function shouldFetchCatalogDetail(state, catalogId) {
    if (!catalogId) return false;
    var item = getCatalogDetail(state, catalogId);
    if (item) {
        var loaded = getLoadTimeForCatalogDetail(state, catalogId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isCatalogDetailLoading(state, catalogId);
    return !loading;
};

var whichCatalogDetailsNeeded = function whichCatalogDetailsNeeded(state, catalogIds) {
    return catalogIds.filter(function (catalogId) {
        return shouldFetchCatalogDetail(state, catalogId);
    });
};

/* ACTION CREATORS */
var loadCatalogDetails = function loadCatalogDetails(catalogIds) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: catalogIds,
                                type: LOAD_CATALOG_DETAILS_REQUEST
                            });
                            _context.next = 6;
                            return _api.CatalogDetail.fetchCatalogDetailsByIds({
                                catalogIds: catalogIds,
                                deployment: deployment
                            });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogIds: catalogIds },
                                payload: response.data,
                                type: LOAD_CATALOG_DETAILS_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { catalogIds: catalogIds },
                                payload: _context.t0,
                                type: LOAD_CATALOG_DETAILS_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchCatalogDetailsIfNeeded = exports.fetchCatalogDetailsIfNeeded = function fetchCatalogDetailsIfNeeded(catalogIds) {
    return function (dispatch, getState) {
        var needed = whichCatalogDetailsNeeded(getState(), catalogIds);
        if (needed.length) {
            return dispatch(loadCatalogDetails(needed));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogDetail.js
// module id = 1mgj
// module chunks = 60